/* eslint-disable react/no-unknown-property */
/* eslint-disable prettier/prettier */
/** @jsx jsx */

import React from 'react';
import { Box, jsx } from 'theme-ui';
import './rings.css';

function Rings() {
  return (
    <Box className="container">
      <Box sx={{ marginTop: `-14px` }}>
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#fff" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{ marginTop: [`-1020px`, `-1000px`], marginLeft: [`40px`, `80px`] }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          marginTop: [`-1040px`, `-1000px`],
          marginLeft: [`100px`, `140px`],
        }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          marginTop: [`-1045px`, `-1000px`],
          marginLeft: [`160px`, `200px`],
        }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          marginTop: [`-1048px`, `-1000px`],
          marginLeft: [`220px`, `260px`],
        }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          marginTop: [`-1048px`, `-1000px`],
          marginLeft: [`280px`, `320px`],
        }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box
        sx={{
          marginTop: [`-1048px`, `-1020px`],
          marginLeft: [`340px`, `420px`],
        }}
      >
        <svg
          width="992"
          height="1060"
          viewBox="0 0 992 1060"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1082.15 1058.73C1679.25 1058.73 2163.29 821.949 2163.29 529.865C2163.29 237.781 1679.25 1 1082.15 1C485.046 1 1 237.781 1 529.865C1 821.949 485.046 1058.73 1082.15 1058.73Z"
            sx={{ stroke: `text` }}
            stroke-opacity="0.5"
            stroke-miterlimit="10"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2572_1835"
              x1="1082.15"
              y1="1"
              x2="1082.15"
              y2="1058.73"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#24400E" />
              <stop offset="0.609375" stop-color="#C4C4C4" stop-opacity="0" />
              <stop offset="0.911458" stop-color="#0F0F0F" />
              <stop offset="1" stop-color="#D3EEBE" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Box>
  );
}

export default Rings;
